<template>
    <v-container>
        <v-card v-if="!showSuccessAlert" class="pa-4 rounded-lg">

            <v-card-text>

                <p class="mb-4">
                    Por favor, complete el siguiente formulario para cargar su apto médico.
                    <ol>
                        <li>Complete el campo DNI</li>
                        <li>Seleccione un archivo de su telefono o PC. </li>
                        <li>Presione el botón "Enviar Apto Médico".</li>
                    </ol>
                </p>

                <v-form v-if="!showSuccessAlert" ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                    <v-text-field v-model="dni" :rules="dniRules" label="Número de Documento (DNI)" required outlined
                        dense placeholder="Ingrese solo números" class="mb-4"
                        @keypress="allowOnlyNumbers"></v-text-field>

                    <p class="font-weight-medium mb-2">Adjuntar Documento:</p>
                    <FileUpload :accept="'image/*,application/pdf'" :uploadUrl="uploadUrl"
                        @upload-success="handleFileUploadSuccess" @upload-error="handleFileUploadError"
                        @reset="resetFile">
                    </FileUpload>

                    <v-btn :disabled="disableSubmitForm" color="success" class="mt-6"
                        type="submit" block large>
                        <v-icon left>mdi-send</v-icon>
                        Enviar apto médico
                    </v-btn>

                    <v-alert v-if="submitStatus" :type="submitStatus.type" dense text class="mt-4">
                        {{ submitStatus.message }}
                    </v-alert>
                </v-form>                
            </v-card-text>
        </v-card>

        <div v-if="showSuccessAlert" class="success-banner">
            <div class="icon-container">
                <svg class="check-icon" viewBox="0 0 24 24">
                    <path fill="white" d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                </svg>
            </div>
            <div class="message">
                <h2>Todo salio bién</h2>
                <p>Gracias por enviar tu apto medico!</p>
                <p>Próximamente lo estaremos validando. </p>
            </div>
        </div>
    </v-container>
</template>

<script>
// Importante: Necesitarás una librería como axios para hacer peticiones HTTP reales
// import axios from 'axios';
import FileUpload from './FileUpload.vue';
import api from '../../../../api/aptos'; // Asegúrate de que la ruta sea correcta
import axios from 'axios';

export default {
    components: {
        FileUpload,
    },
    name: 'DniUploadForm',
    data: () => ({
        showSuccessAlert: false,
        token: null,
        valid: false,
        dni: '',
        dniRules: [
            v => !!v || 'El DNI es requerido',
            v => /^\d+$/.test(v) || 'El DNI solo debe contener números',
            v => (v && v.length >= 7 && v.length <= 8) || 'El DNI debe tener entre 7 y 8 dígitos',
        ],
        fileName: null,
        filePath: null,
        fileType: null,
        submitStatus: null,
    }),

    computed: {
        uploadUrl() {
            return `apto-medico/${this.token}/subir-apto`;
        },
        disableSubmitForm() {
            return !this.valid || !this.dni || !this.fileName || !this.filePath || !this.fileType;
        }
    },

    mounted() {
        // Supone que el token se pasa en la URL como query param (e.g., ?token=...)
        const token = this.$route.params.token;
        if (token) {
            this.token = token;
            this.validateToken(token);

        } else {
            console.error("Token no encontrado en la URL");
        }
    },


    methods: {

        validateToken(token) {
            api.getTokenInfo(token)
                .then(response => {
                    console.log("Token validado:", response.data);
                    this.token = response.data.token;
                    this.loading = false;
                })
                .catch(error => {
                    console.error("Error al obtener la información:", error);
                    this.$router.push({ name: "not-found" });
                }).finally(() => {
                    this.loading = false;
                });
        },



        allowOnlyNumbers(evt) {
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
        },

        handleFileUploadSuccess($event) {

            const { uploadedFileName, uploadedFilePath, uploadedFileType } = $event; // Desestructura el evento de éxito

            this.fileName = uploadedFileName; // Guarda el ID del archivo subido
            this.filePath = uploadedFilePath; // Guarda la ruta del archivo subido
            this.fileType = uploadedFileType; // Guarda el tipo de archivo subido

            console.log('Archivo subido:', { uploadedFileName, uploadedFilePath, uploadedFileType });
        },

        resetFile() {
            this.fileName = null; // Resetea el ID del archivo
            this.filePath = null; // Resetea la ruta del archivo
            this.fileType = null; // Resetea el tipo de archivo
        },

        handleFileUploadError($event) {
            this.uploadError = $event.errorMessage; // Guarda el mensaje de error
            console.error('Error al subir el archivo:', this.uploadError);
        },

        /**
         * Valida el formulario y simula el envío de datos.
         */
        async submit() {
            this.submitStatus = null; // Limpia estado anterior
            if (this.$refs.form.validate() && (this.fileName && this.filePath && this.fileType)) {
                console.log('Formulario válido. Simulando envío...');
                console.log('DNI a enviar:', this.dni);
                console.log('ID de archivo a enviar:', this.fileName);


                try {
                    const response = await axios.post(`apto-medico/${this.token}/enviar-apto`, {
                        document: this.dni,
                        file_name: this.fileName,
                        file_path: this.filePath,
                        file_type: this.fileType
                    });
                    console.log('Formulario enviado:', response.data);
                    this.submitStatus = { type: 'success', message: 'Formulario enviado con éxito.' };
                    this.showSuccessAlert = true; // Muestra el mensaje de éxito
                    // this.reset(); // Opcional: resetear
                } catch (error) {
                    console.error('Error al enviar formulario:', error);
                    this.submitStatus = { type: 'error', message: 'Error al enviar el formulario.' };
                }



            } else if (!(this.fileName && this.filePath && this.fileType)) {
                this.submitStatus = { type: 'warning', message: 'Por favor, carga el archivo adjunto primero.' };
                console.log('Intento de envío fallido: Falta ID de archivo.');
            } else {
                console.log('Intento de envío fallido: Formulario inválido.');
            }
        },


        /**
         * Resetea todo el formulario.
         */
        reset() {
            this.$refs.form.resetValidation(); // Resetea la validación de Vuetify
            this.dni = '';
            this.submitStatus = null;

        },
    },
}
</script>

<style scoped>
/* Estilos opcionales para mejorar la apariencia */
.v-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Puedes añadir estilos para hacer la zona de drop más obvia si lo deseas */
/* .v-file-input .v-input__slot {
    border: 2px dashed grey;
    background-color: #f9f9f9;
  } */

.success-banner {
    width: 100%;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.icon-container {
    background: #6abf69;
    padding: 20px;
}

.check-icon {
    width: 40px;
    height: 40px;
}

.message {
    padding: 15px;
    font-family: Arial, sans-serif;
    color: #333;
}

.message h2 {
    font-size: 18px;
    margin: 10px 0;
    font-weight: bold;
}

.message p {
    font-size: 14px;
    color: #666;
}
</style>